export default {
  modals: {
    delete_payment_method: {
      title: 'Bist du dir sicher, dass du diese Zahlungsmethode entfernen möchtest?',
    },
  },
  buttons: {
    confirm: 'Bestätigen',
    cancel: 'Abbrechen',
  },
  toasts: {
    failed_to_delete_payment_method: 'Zahlungsmethode konnte nicht gelöscht werden',
    payment_method_deleted: 'Zahlungsmethode wurde gelöscht',
  },
};
